import vxCartProductTile from '../../manage-shopping-cart/vx-cart-product-tile/vx-cart-product-tile.vue';
import globals from '../../common/globals';
import BundleService from '../../common/services/bundle-service';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import { cartEventBus, globalEventBus } from '../../../modules/event-bus';

export default {
  name: 'vx-bundle-details',
  components: {
    vxCartProductTile,
    vxSpinner,
  },
  props: {
    // Data of bundle product in the cart
    bundleData: {
      type: Object,
      required: true,
    },
    // Installation price data
    installationPrice: {
      type: Object,
      required: true,
    },
    // Promotion data
    promotionData: {
      type: Object,
      required: true,
    },
    // Text coming from property file
    i18n: {
      type: Object,
      required: true,
    },
    // Indicator for lease error
    customerLeaseable: {
      type: Boolean,
    },
  },
  data() {
    return {
      globals,
      bundleId: '',
      bundleNumber: '',
      bundleService: new BundleService(),
    };
  },
  created() {
    this.bundleId = this.bundleData.id;
    this.bundleNumber = this.bundleData.number;
  },
  computed: {
    updateBundleUrl() {
      return `${this.globals.getNavBaseUrl()}${this.globals.navigations.bundlePage}/?bundleId=${this.bundleId}&bundleNo=${this.bundleNumber}&update=true`;
    },
  },
  mounted() {

  },
  methods: {
    /**
     * This function removes bundle product from cart
     */
    removeBundleFromCart() {
      this.$refs.spinner.showSpinner();
      this.bundleService.deleteBundle({}, (response) => {
        if (response.data) {
          cartEventBus.$emit('cart-update');
          globalEventBus.$emit('announce', 'product deleted');
          this.$refs.spinner.hideSpinner();
        }
      }, () => {
        this.$refs.spinner.hideSpinner();
      }, this.bundleNumber);
    },
    /**
     * This function handles the maximum product count for a leaf bundle
     * @param  {Object} bundle bundle products data
     */
    handleLeafBundleMaxCount(bundle) {
      return bundle.products.length === bundle.maxItemsAllowed;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/manage-shopping-cart/vx-bundle-details/vx-bundle-details.js